import { IPushesViewContext, PushesViewContext } from '../../pushesViewContext/pushesViewState/pushesViewContext';
import React, { useContext } from 'react';
import { UserRoles, RestaurantNotificationEventType } from 'types';
import ControlButton from './components/ControlButton';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from 'modules/CustomersAndRestaurants/Restaurants/RestaurantFullInfo/restaurantFullInfoState/restaurantFullInfoContext';
import { useRoleAccess } from 'hooks/useRoleAccess';
import style from './Controls.module.scss';

export const Controls: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const { changeTypeOfModalWindow, setPushEventType } = useContext<IPushesViewContext>(PushesViewContext);
	const hasFullAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const hasAccessForClientManager = useRoleAccess([UserRoles.CLIENT_MANAGER, UserRoles.GROUP_MANAGER]);
	const hasAccessForRestaurantManager = useRoleAccess([UserRoles.RESTAURANT_MANAGER]);

	const handlePush = (eventType: RestaurantNotificationEventType) => {
		if (restaurantForFullInfo) {
			changeTypeOfModalWindow('confirm');
			setPushEventType(eventType);
		}
	};

	return (
		<div className={style.container} data-test="Controls">
			<div className={style.wrapper}>
				<ControlButton
					label="pushUpdateAllSettings"
					onClick={() => handlePush(RestaurantNotificationEventType.PushUpdateAllSettings)}
					isShowControl={hasFullAccess || hasAccessForClientManager}
				/>
				<ControlButton
					label="pushUpdateMainSettings"
					onClick={() => handlePush(RestaurantNotificationEventType.PushUpdateMainSettings)}
					isShowControl={hasFullAccess || hasAccessForClientManager || hasAccessForRestaurantManager}
				/>
				<ControlButton
					label="pushUpdateGames"
					onClick={() => handlePush(RestaurantNotificationEventType.PushUpdateGames)}
					isShowControl={hasFullAccess}
				/>
				<ControlButton
					label="pushUpdateTeasers"
					onClick={() => handlePush(RestaurantNotificationEventType.PushUpdateTeasers)}
					isShowControl={hasFullAccess || hasAccessForClientManager || hasAccessForRestaurantManager}
				/>
				<ControlButton
					label="pushUpdateConfigurationFile"
					onClick={() => handlePush(RestaurantNotificationEventType.PushUpdateConfigurationFile)}
					isShowControl={hasFullAccess || hasAccessForClientManager}
				/>
				<ControlButton
					label="pushUpdateRestaurantSettings"
					onClick={() => handlePush(RestaurantNotificationEventType.PushUpdateRestaurantSettings)}
					isShowControl={hasFullAccess || hasAccessForClientManager || hasAccessForRestaurantManager}
				/>
				<ControlButton
					label="pushUpdateRestaurantMenu"
					onClick={() => handlePush(RestaurantNotificationEventType.PushUpdateRestaurantMenu)}
					isShowControl={hasFullAccess || hasAccessForClientManager || hasAccessForRestaurantManager}
				/>
				<ControlButton
					label="pushCloseDay"
					onClick={() => handlePush(RestaurantNotificationEventType.PushCloseDay)}
					isShowControl={hasFullAccess || hasAccessForClientManager}
				/>
				<ControlButton
					label="pushRestartApp"
					onClick={() => handlePush(RestaurantNotificationEventType.PushRestartApp)}
					isShowControl={hasFullAccess}
				/>
				<ControlButton
					label="pushDownloadFirmware"
					onClick={() => handlePush(RestaurantNotificationEventType.PushDownloadFirmware)}
					isShowControl={hasFullAccess}
				/>
				<ControlButton
					label="pushUpdateLauncherConfig"
					onClick={() => handlePush(RestaurantNotificationEventType.PushUpdateLauncherConfig)}
					isShowControl={hasFullAccess}
				/>
				<ControlButton
					label="pushRebootDevices"
					onClick={() => handlePush(RestaurantNotificationEventType.PushRebootDevices)}
					isShowControl={hasFullAccess || hasAccessForClientManager}
				/>
				<ControlButton
					label="pushShutdownDevices"
					onClick={() => handlePush(RestaurantNotificationEventType.PushShutdownDevices)}
					isShowControl={hasFullAccess || hasAccessForClientManager}
				/>
				<ControlButton
					label="syncMenu"
					onClick={() => handlePush(RestaurantNotificationEventType.SynchronizationMenu)}
					isShowControl={hasFullAccess || hasAccessForClientManager || hasAccessForRestaurantManager}
				/>
				<ControlButton
					label="pushUpdateEncryptedPaymentConfig"
					onClick={() => handlePush(RestaurantNotificationEventType.PushUpdateEncryptedPaymentConfig)}
					isShowControl={hasFullAccess}
				/>
				<ControlButton
					label="priceUpdate"
					onClick={() => handlePush(RestaurantNotificationEventType.PushPriceUpdate)}
					isShowControl={hasFullAccess || hasAccessForClientManager || hasAccessForRestaurantManager}
				/>
				<ControlButton
					label="pushUpdateVideos"
					onClick={() => handlePush(RestaurantNotificationEventType.PushUpdateVideos)}
					isShowControl={hasFullAccess}
				/>
				<ControlButton
					label="pushDmsNetworkParams"
					onClick={() => handlePush(RestaurantNotificationEventType.PushDmsNetworkParams)}
					isShowControl={hasFullAccess}
				/>
				<ControlButton
					label="pushUpdateTlsCertificate"
					onClick={() => handlePush(RestaurantNotificationEventType.PushUpdateTlsCertificate)}
					isShowControl={hasFullAccess}
				/>
				<ControlButton
					label="pushRestaurantMenu"
					onClick={() => handlePush(RestaurantNotificationEventType.PushRestaurantMenu)}
					isShowControl={hasFullAccess || hasAccessForClientManager || hasAccessForRestaurantManager}
				/>
			</div>
		</div>
	);
};
